import { authApi } from "@api";
import { BankConfig, FundingProfileType, MemberBankFundingType } from "kz-ui-sdk";
import { useCallback, useMemo } from "react";

const NO_INFO_BANK_TYPES = [MemberBankFundingType.IFSC, MemberBankFundingType.CLABE];
const DISPLAY_BANK_NAME_KEYS = [
  MemberBankFundingType.UPI,
  MemberBankFundingType.IFSC,
  MemberBankFundingType.PIX,
  MemberBankFundingType.CLABE,
];

const usePaymentInfo = () => {
  const { data } = authApi.useGetProfileQuery();
  const paymentMethods = useMemo(() => {
    const bankMap = data?.bankInfos;
    const eWalletMap = data?.ewalletInfos;

    return {
      ...Object.fromEntries(
        Object.entries(bankMap || {}).map(([key, value]) => [
          key,
          {
            ...value,
            type: FundingProfileType.Bank,
            displayName: DISPLAY_BANK_NAME_KEYS?.includes(value.code as MemberBankFundingType)
              ? `${value.name} (${value.code})`
              : value.code,
          },
        ]),
      ),
      ...Object.fromEntries(
        Object.entries(eWalletMap || {}).map(([key, value]) => [
          key,
          { ...value, type: FundingProfileType.EWallet, displayName: value.name },
        ]),
      ),
    } as Record<string, BankConfig & { type: FundingProfileType; displayName: string; noIcon?: boolean }>;
  }, [data]);

  const getPaymentMethodByKey = useCallback(
    (key?: string, bankType?: MemberBankFundingType) => {
      if (bankType) {
        let name, code;
        switch (bankType) {
          case MemberBankFundingType.IFSC:
          case MemberBankFundingType.CLABE:
          case MemberBankFundingType.PIX:
          case MemberBankFundingType.UPI:
            name =
              (key ? paymentMethods[key]?.name : "") ||
              (NO_INFO_BANK_TYPES?.includes(bankType) ? bankType?.toUpperCase() : "");
            code = (key ? paymentMethods[key]?.code : "") || key;
            return {
              ...(key ? paymentMethods[key] || {} : {}),
              name,
              noIcon: NO_INFO_BANK_TYPES.includes(bankType),
              code,
              type: FundingProfileType.Bank,
              displayName: `${name || ""} (${code || ""})`,
            };
        }
      }
      if (!key) return undefined;
      return paymentMethods[key];
    },
    [paymentMethods],
  );

  return {
    paymentMethods,
    getPaymentMethodByKey,
  };
};

export default usePaymentInfo;
